module.exports = __webpack_public_path__ + "static/media/white-tick-with-green-bg.c5782577.svg";